/**
 *
 * Component: ErrorBoundary
 * Date: 02/11/2020
 *
 */

import Text from 'components/common/Text';
import React from 'react';
import history from 'utils/history';
import styles from './style.module.css';

type MyProps = { children: React.ReactNode };
type MyState = { hasError: boolean };

export default class ErrorBoundary extends React.Component<MyProps, MyState> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      // You can render any custom fallback UI
      return (
        <div className={styles.pageError}>
          <h1>Oops!!</h1>
          <h3>
            Something went wrong. Please click the link below to take down
            manual note
            <br />
          </h3>
          <Text
            onClick={() => {
              history.push('/idle');
              window.location.reload();
            }}
            text="Reset to initial state"
            type="information"
            className="gray underline pointer"
          />
          <p className={styles.information}>
            if this persists, check your internet connection or mail us at
            <br />
            <a href="mailto:support@prodigaltech.com">
              support@prodigaltech.com
            </a>
          </p>
        </div>
      );
    }
    // eslint-disable-next-line react/prop-types
    return children;
  }
}
